module.exports = __webpack_public_path__ + "static/media/D15.d2ee8dc7.svg";